import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import {SFComponent, SFSchema} from '@delon/form';
import {NzMessageService, NzTableComponent} from "ng-zorro-antd";
import {CacheService} from "@delon/cache";
import {SystemDictEditComponent} from "./edit/edit.component";
import {DictService} from "@ecip/service";

@Component({
  selector: 'app-system-dict',
  templateUrl: './dict.component.html',
  styleUrls: ['./dict.component.less']

})
export class SystemDictComponent implements OnInit {

  isVisible = false;
  isOkLoading = false;

  @ViewChild('st') st: STComponent;

  @ViewChild('sf') sf: SFComponent;
  searchSchema: SFSchema = {
    properties: {
      vkey: {
        type: 'string',
        title: 'ç¼ç '
      }
    }
  };

  @ViewChild('nzTable') nzTable: NzTableComponent;
  selectId;
  data = [];
  dataList = {};

  constructor(
    private modal: ModalHelper,
    private msgSrv: NzMessageService,
    public dictService: DictService,
  ) {
  }

  ngOnInit() {
    // console.log(this.nzTable);
    this.dictService.getList(this.sf.value).subscribe((res: any) => {
      this.data = res;
      this.data.forEach(item => {
        this.dataList[item.id] = item;
      });
    });
  }

  addChild(parentId) {
    this.selectId = parentId;
    this.add(false);
  }

  add(isRoot : boolean) {
    let parent;
    if (!isRoot) {
      if (!this.selectId) {
        this.msgSrv.warning("è¯·éæ©ç¶èç¹");
        return;
      }
      parent = this.dataList[this.selectId];
    }
    this.modal
      .createStatic(SystemDictEditComponent, {
        i: {} , isRoot: isRoot, parent: parent})
      .subscribe((res) => {
        this.dataList[res.id] = res;
        if (isRoot) {
          this.data.push(res);
          return;
        }
        if (!parent.children) {
          parent.children = [];
          parent.expand = true;
        }
        parent.children.push(res);
      });
  }

  edit(item) {
    this.modal
      .createStatic(SystemDictEditComponent, { record: item })
      .subscribe((res) => {
        if(res.length > 1) {
          this.dictService.getList().subscribe((result: any) => {
            this.data = result;
            this.data.forEach(it => {
              this.dataList[it.id] = it;
            });
          });
        }
        else {
          item = Object.assign(item, res[0]);
          this.dataList[res.id] = res[0];
        }
      });
  }

  collapse(data: any, $event: boolean): void {
    if (!$event || data.children.length > 0) {
      return;
    }

    this.dictService.getChildren(data.id).subscribe(res => {
      data.children = res;
      data.children.forEach(item => {
        this.dataList[item.id] = item;
      });
    });
  }

  deleteModal(): void {
    this.isVisible = true;
  }

  deleteOk(item) {
    this.isOkLoading = true;
    this.dictService.deleteById(item.id).subscribe(res => {
      this.isVisible = false;
      this.isOkLoading = false;
      this.msgSrv.success('å é¤æå');
      //æ ¹èç¹
      if (!item.pid) {
        this.data = this.data.filter(_item => _item.id !== item.id);
        this.dataList[item.id] = null;
        return;
      }
      //å­èç¹
      this.dataList[item.pid].children =
        this.dataList[item.pid].children.filter(_item => _item.id !== item.id);
    });
  }

  deleteCancel(): void {
    this.isVisible = false;
  }

}
